import { render, staticRenderFns } from "./PaymentByMonths.vue?vue&type=template&id=35818c10&"
import script from "./PaymentByMonths.vue?vue&type=script&lang=js&"
export * from "./PaymentByMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports